import { normalizeDate, onlyNumbers, normalizeAll, numberMaxLength } from '@widergy/web-utils/lib/normalize';
import { required, lengthEquals, validDate, minLength, maxDate } from '@widergy/web-utils/lib/validate';
import moment from 'moment';

import { message } from 'utils/stringUtils';

const MAX_DATE = moment()
  .add('2', 'days')
  .format('DD-MM-YYYY');

export const DESTINATION_COMERCE = 'Comercio';
export const DESTINATION_CONSTRUCTION = 'Consorcio, obra y otros';
export const SELECT = 'select';
export const ACCOUNT_NUMBER = 'accountNumber';
export const ACCOUNT_NUMBER_SELECT = 'accountNumberSelect';
export const AC_CREDIT_POSSESSION = 'accreditPossession';

export const WARRANTY_CHARGE_POSESSIONS = [
  'Contrato de locación',
  'Contrato de comodato',
  'Constatación de domicilio'
];

export const registerAccountFields = [
  {
    id: 1,
    type: 'Fields::Text',
    order: 1,
    key: 'address',
    required: false,
    title: 'Dirección del suministro ingresado',
    read_only: true,
    validate: [required(message('Translation:fieldRequired'))]
  },
  {
    id: 2,
    type: 'Fields::Radio',
    order: 2,
    title: 'Destino del suministro eléctrico',
    key: 'supplyDestination',
    required: true,
    field_options: [
      { id: 10, name: 'Vivienda', value: 'Vivienda', order: 1, key: 1 },
      { id: 11, name: 'Comercio', value: 'Comercio', order: 2, key: 2 },
      { id: 12, name: 'Consorcio, obra y otros', value: 'Consorcio, obra y otros', order: 3, key: 3 }
    ],
    validate: [required(message('Translation:fieldRequired'))]
  },
  {
    id: 3,
    type: 'Fields::Radio',
    order: 3,
    title: 'Acreditar tenencia del inmueble',
    key: 'accreditPossession',
    required: true,
    field_options: [
      { id: 1, name: 'Escritura', value: 'Escritura', order: 1, key: 1 },
      { id: 2, name: 'Boleto de compra-venta', value: 'Boleto de compra-venta', order: 2, key: 2 },
      { id: 3, name: 'Contrato de locación', value: 'Contrato de locación', order: 3, key: 3 },
      { id: 4, name: 'Contrato de comodato', value: 'Contrato de comodato', order: 4, key: 4 },
      { id: 5, name: 'Constatación de domicilio', value: 'Constatación de domicilio', order: 5, key: 5 }
    ],
    validate: [required(message('Translation:fieldRequired'))]
  },
  {
    id: 4,
    type: 'Fields::Text',
    order: 4,
    title: 'Por favor ingrese la fecha a partir de la cual usted tiene la posesión del inmueble',
    key: 'possessionDate',
    required: true,
    validate: [
      required(message('Translation:fieldRequired')),
      lengthEquals(10, message('Validations:invalidFormat')),
      validDate(message('Validations:invalidFormat')),
      maxDate(MAX_DATE, message('Validations:maxDate', { date: MAX_DATE }))
    ],
    visibility_parent_field_key_id: 3,
    visibility_parent_field_option_values: [1, 2, 5],
    normalize: normalizeDate
  },
  {
    id: 5,
    type: 'Fields::Text',
    order: 6,
    title: 'Ingrese datos catastrales Partida',
    key: 'cadastreP',
    required: true,
    validate: [
      required(message('Translation:fieldRequired')),
      minLength(6, message('Validations:minSixDigits'))
    ],
    visibility_parent_field_key_id: 3,
    visibility_parent_field_option_values: [1],
    normalize: normalizeAll([onlyNumbers, numberMaxLength(6)])
  },
  {
    id: 6,
    type: 'Fields::Text',
    order: 5,
    title: 'Ingrese datos catastrales Prepartida',
    key: 'cadastrePP',
    required: true,
    validate: [
      required(message('Translation:fieldRequired')),
      minLength(3, message('Validations:minThreeDigits'))
    ],
    visibility_parent_field_key_id: 3,
    visibility_parent_field_option_values: [1],
    normalize: normalizeAll([onlyNumbers, numberMaxLength(3)])
  },
  {
    id: 7,
    type: 'Fields::Text',
    order: 7,
    title: 'Fecha de inicio de contrato',
    key: 'contractInitialDate',
    required: true,
    validate: [
      required(message('Translation:fieldRequired')),
      lengthEquals(10, message('Validations:invalidFormat')),
      validDate(message('Validations:invalidFormat')),
      maxDate(MAX_DATE, message('Validations:maxDate', { date: MAX_DATE }))
    ],
    visibility_parent_field_key_id: 3,
    visibility_parent_field_option_values: [3, 4],
    normalize: normalizeDate
  },
  {
    id: 8,
    type: 'Fields::Text',
    order: 8,
    title: 'Fecha de fin de contrato',
    key: 'contractEndDate',
    required: true,
    validate: [
      required(message('Translation:fieldRequired')),
      lengthEquals(10, message('Validations:invalidFormat')),
      validDate(message('Validations:invalidFormat'))
    ],
    visibility_parent_field_key_id: 3,
    visibility_parent_field_option_values: [3, 4],
    normalize: normalizeDate
  }
];
